import styled from "styled-components";

export const StyledLabelWrapper = styled.div`
  display: flex;
  align-items: baseline;
  > div {
    ${({ theme }) => theme.fontStyles.InterfaceCopy}
    padding-bottom: 4px;
    padding-top: 8px;

    * {
      margin: 0 !important;
      font-weight: inherit;
      font-size: inherit;
      line-height: inherit;
    }

    p {
      min-height: 1em;
    }
  }

  > span {
    color: ${({ theme }) => theme.colors.neutralsLight};
    margin-left: 4px;
    vertical-align: top;
    display: block;
  }
`;
